import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';

import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import {dateStr, dateAndTime} from '../utils/TimeFormatter';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RC from '../utils/ReactiveClock';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import EditCustomer from '../components/EditCustomer';

let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

const formStyle = {
  marginLeft: 16
};

export default
@observer class CustomerEditPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  cancelUpdate() {
    AppModel.updateCustomerForm.reset();
    this.context.router.goBack();
  }

  performUpdate() {
    return AppModelUtils.updateCustomer()
    .then(()=> {
      this.context.router.push(`/customers`)
      return null;
    })
    .catch(()=> {
      console.log("Customer update rejected.");
    });
  }

  
  performDelete() {
   if (confirm(uiMsg('CE_CONFIRM_DELETE',"This customer will be deleted. Do you want to proceed?"))) {
      return AppModelUtils.deleteCustomer()
      .then(()=> {
        this.context.router.push(`/customers`)
        return null;
      })
      .catch(()=> {
        console.log("Customer delete rejected.");
      });
    } else {
      return null;
    } 
  }

  render() {
    let form = AppModel.updateCustomerForm;
    let customer = form.customer;
    return (
      <div style={pageStyle}>
        <PageLoading loading={
               AppModel.fetchingCustomerDetails
            || AppModel.updatingCustomerDetails
            || AppModel.fetching_customer_segments
            || AppModel.fetching_job_types
            || AppModel.fetchingSupportedCountries
          }>
          <h2 style={headerStyle}>{uiMsg('CE_EDIT_DATA_FOR',"Edit customer data for")} {customer.id}</h2>
          <EditCustomer form={form} />
          <Toolbar>
            <ToolbarGroup firstChild={true}></ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <FlatButton
                      onTouchTap={this.cancelUpdate.bind(this)}>
                      {uiMsg('CE_CANCEL',"Cancel")}
              </FlatButton>
              <RaisedButton primary
                            onTouchTap={this.performUpdate.bind(this)}>
                            {uiMsg('CE_UPDATE',"Update")}
              </RaisedButton>
              <FlatButton
                      onTouchTap={this.performDelete.bind(this)}>
                      {uiMsg('CE_DELETE',"Delete")}
              </FlatButton>
            </ToolbarGroup>
          </Toolbar>
          {/* added some space at the bottom to allow some scrolling */}
          <div style={{height:"3em"}}></div>
        </PageLoading>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/CustomerEditPage.jsx
 **/